import { Device } from '@/api';

/**
 * Whether a device is effectively using its fall detection license. A pending
 * `set_fall_alert` command reflects the user's intended state, so it overrides
 * the reported config in both directions (a pending enable consumes a license,
 * a pending disable frees one). Falls back to the reported config otherwise.
 */
export function isFallEffectivelyEnabled(device: Device): boolean {
    const pending = device.commands?.find(
        (command) =>
            command.type === 'set_fall_alert' && command.status === 'pending'
    );
    if (pending) {
        return pending.data.fallAlertEnabled ?? false;
    }
    return device.config?.fallAlert?.enabled ?? false;
}

/**
 * Whether a device is effectively using its tilt detection license. See
 * {@link isFallEffectivelyEnabled} for how pending commands are handled.
 */
export function isTiltEffectivelyEnabled(device: Device): boolean {
    const pending = device.commands?.find(
        (command) =>
            command.type === 'set_tilt_alert' && command.status === 'pending'
    );
    if (pending) {
        return pending.data.tiltAlertEnabled ?? false;
    }
    return device.config?.tiltAlert?.enabled ?? false;
}
